import { APP_ENV } from '../constants';

export const getDefaultApp = () => {
  let defaultApps = [] as any;

  if (APP_ENV === 'us-dit') {
    defaultApps = [
      {
        id: 'cdku',
        productName: 'CDK University',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/connectcdk-dit_docebosamlintegration_2/0oa2fvanil0gOVc9V0h8/aln2fvaxaol6QeGs70h8',
        workflows: [],
      },
      {
        id: 'ccp',
        productName: 'Customer Care',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/salesforce/0oa1tbf7j36k7wLLb0h8/24?launchtype=tab',
        workflows: [],
      },
      {
        id: 'crc',
        productName: 'CDK Resource Center',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/connectcdk-dit_enablixdit_1/0oa27fw99zcmV6j0t0h8/aln27fwf133rL2G8t0h8',
        workflows: [],
      },
    ];
  } else if (APP_ENV === 'us-stage') {
    defaultApps = [
      {
        id: 'cdku',
        productName: 'CDK University',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/connectcdk-dit_docebosamlintegration_2/0oa2fvanil0gOVc9V0h8/aln2fvaxaol6QeGs70h8',
        workflows: [],
      },
      {
        id: 'ccp',
        productName: 'Customer Care',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/salesforce/0oa1tbf7j36k7wLLb0h8/24?launchtype=tab',
        workflows: [],
      },
      {
        id: 'crc',
        productName: 'CDK Resource Center',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/connectcdk-dit_enablixdit_1/0oa27fw99zcmV6j0t0h8/aln27fwf133rL2G8t0h8',
        workflows: [],
      },
    ];
  } else if (APP_ENV === 'us-perf') {
    defaultApps = [
      {
        id: 'cdku',
        productName: 'CDK University',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/connectcdk-dit_docebosamlintegration_2/0oa2fvanil0gOVc9V0h8/aln2fvaxaol6QeGs70h8',
        workflows: [],
      },
      {
        id: 'ccp',
        productName: 'Customer Care',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/salesforce/0oa1tbf7j36k7wLLb0h8/24?launchtype=tab',
        workflows: [],
      },
      {
        id: 'crc',
        productName: 'CDK Resource Center',
        unifyAppUrl:
          'https://connectcdk-dit.oktapreview.com/home/connectcdk-dit_enablixdit_1/0oa27fw99zcmV6j0t0h8/aln27fwf133rL2G8t0h8',
        workflows: [],
      },
    ];
  } else if (APP_ENV === 'us-prod') {
    defaultApps = [
      {
        id: 'cdku',
        productName: 'CDK University',
        unifyAppUrl:
          'https://connectcdk.okta.com/home/connectcdk_docebosamlintegration_1/0oarzyn5owoKHsNT11t7/alnrzyqpceqW4kvxU1t7',
        workflows: [],
      },
      {
        id: 'ccp',
        productName: 'Customer Care',
        unifyAppUrl:
          'https://connectcdk.okta.com/home/salesforce/0oauvjgwd8uB5q22U1t7/46?launchtype=tab',
        workflows: [],
      },
      {
        id: 'crc',
        productName: 'CDK Resource Center',
        unifyAppUrl:
          'https://connectcdk.okta.com/home/connectcdk_enablixprod_1/0oa12ld0w91REVOgJ1t8/aln12ld4iwflyZRu81t8',
        workflows: [],
      },
    ];
  }
  return defaultApps;
};
